// Brand assets uploaded by Veronika.
export const PHOTOS = {
  heroPortrait:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/f9rwcyjl_WhatsApp%20Image%202026-06-24%20at%2012.27.01.jpeg",
  aboutPortrait:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/mgtxp8ml_WhatsApp%20Image%202026-06-24%20at%2012.27.01%20%281%29.jpeg",
  finalCtaImage:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/mpivhpvr_WhatsApp%20Image%202026-06-24%20at%2012.27.01%20%282%29.jpeg",
  // Real lifestyle photo working from home (replaces studio portrait for Sessions)
  sessionsImage:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/osyfx2jp_Gemini_Generated_Image_hqmlz0hqmlz0hqml.png",
  // Before/after transformation: waitress → administrative manager
  transformation:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/3cw87j83_WhatsApp%20Image%202026-06-24%20at%2013.30.13.jpeg",
  // Alternate clean portrait, kept for future use
  altPortrait:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/mv174pzs_WhatsApp%20Image%202026-06-24%20at%2012.27.01%20%283%29.jpeg",
};

export const LOGOS = {
  // Brand official horizontal logo with transparent background (preferred)
  horizontal:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/ikmzgtvd_VeronikaconK_Primary_Horizontal_full-color_transparent.png",
  primary:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/c6onfyp6_ChatGPT%20Image%20Jun%2024%2C%202026%2C%2012_41_39%20PM%20%284%29.png",
  reverse:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/2fslxthh_ChatGPT%20Image%20Jun%2024%2C%202026%2C%2012_41_38%20PM%20%281%29.png",
  monogram:
    "https://customer-assets.emergentagent.com/job_experience-forward-2/artifacts/cq0jkghx_ChatGPT%20Image%20Jun%2024%2C%202026%2C%2012_41_38%20PM%20%282%29.png",
};

export const TIDYCAL = {
  clarity: "https://tidycal.com/veronikaht3/career-clarity-session",
  interview: "https://tidycal.com/veronikaht3/interview-training",
  strategy: "https://tidycal.com/veronikaht3/professional-guidance-session",
};
